import {injectable} from 'inversify'
import {RecipientFormStrategyInterface} from '@/src/ports/services/reqipient-strategy'

@injectable()
export class PersonRecipientStrategy implements RecipientFormStrategyInterface {
  readonly type = 'person' as const
}
